import React from "react";

function maskDigits(rawDigits) {
  const digits = rawDigits.replace(/\D/g, "");

  if (digits.length === 0) {
    return "00:00";
  }

  if (digits.length <= 2) {
    const ss = digits.padStart(2, "0");
    return `00:${ss}`;
  }

  const mm = digits.slice(0, -2);
  const ss = digits.slice(-2);

  return `${mm.padStart(2, "0")}:${ss}`;
}

function normalizeDigits(rawDigits) {
  const digits = rawDigits.replace(/\D/g, "");
  if (!digits) return { minutes: 0, seconds: 0 };

  let m = 0, s = 0;

  if (digits.length <= 2) {
    s = Number(digits);
  } else {
    m = Number(digits.slice(0, -2));
    s = Number(digits.slice(-2));
  }

  // Normalize AFTER blur only
  if (s > 59) {
    m += Math.floor(s / 60);
    s = s % 60;
  }

  return { minutes: m, seconds: s };
}

export default function DurationInput({
  id,
  valueSeconds = 0,
  onChange,
  readOnly = false
}) {
  const [digits, setDigits] = React.useState("0");
  const [text, setText] = React.useState("00:00");
  const inputRef = React.useRef(null);

  React.useEffect(() => {
    if (valueSeconds == null) return;

    const minutes = Math.floor(valueSeconds / 60);
    const seconds = valueSeconds % 60;

    const raw = `${minutes}${seconds.toString().padStart(2, "0")}`;

    setDigits(raw);
    setText(`${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`);
  }, [valueSeconds]);

  const handleChange = (e) => {
    const raw = e.target.value;

    const onlyDigits = raw.replace(/\D/g, "");

    const typedDigits = onlyDigits.replace(/^0+(?=\d)/, "");

    setDigits(typedDigits);
    setText(maskDigits(typedDigits));
  };

  const handleBlur = () => {
    const { minutes, seconds } = normalizeDigits(digits);

    const total = minutes * 60 + seconds;

    // Commit to parent
    onChange && onChange(total);

    // Update displayed text to normalized form
    setText(
      `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`
    );
  };

  const handleFocus = () => {
      requestAnimationFrame(() => {
          const el = inputRef.current;
          if (!el) return;
          const len = el.value.length;
          el.setSelectionRange(len, len);
      });
  };

  return (
    <input
      id={id}
      type="text"
      className="form-control"
      style={{
        display: "inline-block",
        width: "90px",
        textAlign: "center",
        fontVariantNumeric: "tabular-nums",
        margin: "10px",
        height: "34px",
      }}
      value={text}
      placeholder="mm:ss"
      readOnly={readOnly}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      inputMode="numeric"
      aria-label="Duration (minutes and seconds)"
      ref={inputRef}
    />
  );
}